import React from "react";
import { Box, Typography } from "@mui/material";
import withStyles from '@mui/styles/withStyles';
import BackArrow from "../../assets/images/arrow-left.svg";
import { useHistory } from "react-router-dom";

const styles = (theme) => ({
  blueBox: {
    position: "absolute",
    color: "#fff",
    zIndex: 100,
    height: 110,
    borderRadius: "0 0 0 70px",
    background:
      "linear-gradient(0deg, rgba(125,204,230,1) 0%, rgba(87,166,219,1) 100%, rgba(125,204,230,1) 0%)",
  },
  content: {
    fontWeight: 300,
    paddingTop: "0px",
    paddingLeft: 70,
  },
  arrow: {
    position: "relative",
    top: "27px",
    left: "-40px",
  },
});

const BlueBoxArrow = ({ classes, text, route }) => {
  let history = useHistory();

  const clickHandler = () => {
    history.push(`${route}`);
    return (e) => {
      e.preventDefault();
    };
  };
  return (
    <Box
      className={classes.blueBox}
      width="100%"
      display="flex"
      alignItems="center"
    >
      <Typography variant="h1" color="inherit" className={classes.content}>
        <div onClick={clickHandler} className={classes.arrow}>
          <img src={BackArrow} alt="back" />
        </div>
        <Box dangerouslySetInnerHTML={{ __html: text }} />
      </Typography>
    </Box>
  );
};

export default withStyles(styles)(BlueBoxArrow);
